import { StyledModal } from 'components/UI/ConfirmationModal/styled';
import { styled } from 'linaria/react';

export const StyledWrapper = styled.div`
  ${StyledModal} {
    width: 100%;
  }
`;
